import { apiRTK } from 'api/api-rtk'

import type { Campaign } from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		getById: create.query<Campaign, string>({
			query: id => ({
				url: `campaigns/${id}`
			})
		})
	}),
	overrideExisting: true
})
